import { FelaCSS, FelaCSSWithCustomSelectors } from '@bridebook/ui';

interface IStyles {
  dateInput: FelaCSSWithCustomSelectors;
  label: FelaCSS;
}

export const componentStyles: IStyles = {
  dateInput: {
    '::-webkit-date-and-time-value': {
      textAlign: 'left',
      minHeight: '22px',
    },
    width: '100%',
  },
  label: {
    fontWeight: 400,
    display: 'block',
  },
};
